import { EmploymentInfo } from "./employment-info.model";
import { LeaveBalanceDTO } from "./leave-balances.model";
import { PaymentInfo, PaymentInfoDTO } from "./payment-info.model";
import { StaffInfo, StaffInfoDTO } from "./staff-info.model";
export interface User {
  id: number;
  email: string;
  fullName: string;
  createdAt?: Date;
  updatedAt?: Date;
  staffInfo?: StaffInfo;
  paymentInfo?: PaymentInfoDTO;
  employmentInfo?: EmploymentInfo;
  role: string;
}

export enum RoleType {
  ADMIN = "ADMIN",
  STAFF = "STAFF",
}

export interface CreateUser {
  email: string;
  password: string;
  fullName: string;
}

export interface OnboardResult {
  userId: number;
  leaveBalances?: LeaveBalanceDTO;
  staffInfo?: StaffInfo;
  employmentInfo?: EmploymentInfo;
  paymentInfo?: PaymentInfo;
}
